import * as React from 'react';
import { sanitizeHTML } from './sanitizeHTML';
export var SanitizeInnerHTMLWrapper = function (_a) {
    var children = _a.children, innerHtml = _a.innerHtml;
    return React.cloneElement(children, { dangerouslySetInnerHTML: { __html: sanitizeHTML(innerHtml) } });
};
//# sourceMappingURL=SanitizeInnerHTMLWrapper.js.map